import AjaxService from '@services/AjaxService';
import BaseRepository from '@repositories/desktop/BaseRepository';

export default class ExternRepository extends BaseRepository {
  protected baseUrl = '';

  public constructor(protected readonly ajaxService: AjaxService) {
    super(ajaxService)
  }

  public buildFileDownloadUrlDownload(recordId: number, fileKey: string): string {
    const url = `/api/desktop/extern/record/${recordId}/filekey/${fileKey}/download`;
    return this.ajaxService.addSessionIdQueryParameter(url);
  }

  public buildFileDownloadUrlShow(recordId: number, fileKey: string): string {
    const url = `/api/desktop/extern/record/${recordId}/filekey/${fileKey}/show`;
    return this.ajaxService.addSessionIdQueryParameter(url);
  }

  public deleteFile(recordId: number, fileKey: string): Promise<any> {
    const url = `/api/desktop/extern/record/${recordId}/filekey/${fileKey}/delete`;
    return this.ajaxService.sendDelete(url);
  }

  public getFilesForRecordExtern(recordId: number): Promise<any> {
    return this.ajaxService.getJson(`/api/desktop/extern/record/${recordId}/files`);
  }
}
